import { NgModule } from '@angular/core';
import { FilterWithCallbackPipe } from './pipes/filter-with-callback-pipe';
import { DisablePaFieldPipe } from './pipes/disable-pa-field-pipe';

@NgModule({
	declarations: [
		FilterWithCallbackPipe,
		DisablePaFieldPipe
	],
	exports: [
		FilterWithCallbackPipe,
		DisablePaFieldPipe
	]
})
export class FiltersModule {
	constructor() { }
}